"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BullShipping() {
  const shouldReduceMotion = useReducedMotion();
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 12
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="shippingusedbull" data-nav="light" className="bg-background text-foreground border-b border-border py-16 md:py-24">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} variants={cardVariants} className="border border-border bg-card text-card-foreground shadow-xs">
          {/* Main Card Content */}
          <div className="p-6 sm:p-10 md:p-12">
            <h2 className="font-serif text-2xl font-bold uppercase tracking-tight text-foreground sm:text-3xl md:text-4xl">
              Shipping a Used Mechanical Bull
            </h2>

            <div className="mt-6 space-y-4 text-base leading-relaxed text-muted-foreground">
              <p>
                Used mechanical bulls are large pieces of equipment and may require planned equipment delivery. Shipping arrangements can depend on the individual machine, packed dimensions, total weight, origin, destination and unloading access.
              </p>
              <p>
                Before completing a purchase, confirm what equipment is being shipped, whether components ship together or separately, packed dimensions where available, destination access, unloading requirements and the delivery arrangement.
              </p>
              <p className="font-medium text-foreground">
                The exact process can vary from one used machine to another.
              </p>
            </div>

            {/* Action Bar */}
            <div className="mt-8 pt-6 border-t border-border">
              <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none px-6 py-2.5 font-serif text-base uppercase tracking-wider font-semibold transition-[color,background-color,border-color,box-shadow]">
                <Link to="/ShippingWarrantyAndOrderingPage">
                  <span>View Shipping Information</span>
                  <ArrowUpRight className="size-4" aria-hidden="true" />
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}